<template>
  <aside v-if="visible" class="ux-cookie-banner" aria-labelledby="cookie-title">
    <div class="ux-cookie-copy">
      <h2 id="cookie-title">Your cookie choices</h2>
      <p>Essential cookies keep the site working. Optional analytics help us improve your experience.</p>
      <button @click="openPrefs = !openPrefs" class="ux-text-button" :aria-expanded="openPrefs" aria-controls="cookie-preferences">Manage preferences</button>
    </div>
    <div class="ux-cookie-actions">
      <button @click="reject" class="ux-button ux-button-secondary">Reject non-essential</button>
      <button @click="acceptAll" class="ux-button ux-button-secondary">Accept all</button>
    </div>
    <div v-if="openPrefs" id="cookie-preferences" class="ux-cookie-preferences">
      <label for="cookie-analytics"><input id="cookie-analytics" type="checkbox" v-model="analytics" /><span>Allow analytics cookies <small>Optional. Off by default.</small></span></label>
      <button @click="save" class="ux-button ux-button-primary">Save choices</button>
    </div>
  </aside>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { getConsent, setConsent } from '@/utils/cookies'

const openPrefs = ref(false)
const analytics = ref(false)
const visible = ref(true)

const refreshVisible = () => {
  const c = getConsent()
  analytics.value = c.analytics === true
  visible.value = c.analytics === null
}

onMounted(() => {
  refreshVisible()
  window.addEventListener('cookie-consent-changed', refreshVisible)
})

onBeforeUnmount(() => {
  window.removeEventListener('cookie-consent-changed', refreshVisible)
})

const acceptAll = () => {
  setConsent({ analytics: true })
  visible.value = false
}

const reject = () => {
  setConsent({ analytics: false })
  visible.value = false
}

const save = () => {
  setConsent({ analytics: analytics.value })
  visible.value = false
}
</script>
